import {
    EventCardImage,
    EventCardLink,
    EventCardLinkProps,
    EventImageProps,
    EventImageTokens,
    FormattedEvent,
    getCarouselWidget,
} from '@eventbrite/event-renderer';
import React from 'react';
import { Carousel, CarouselProps } from './Carousel';
import styles from './EventCardCarousel.module.scss';

export type EventCardCarouselProps = React.PropsWithoutRef<{
    event: FormattedEvent;
    isLazyImage: EventImageProps['loading'];
    linkProps: EventCardLinkProps;
    tokens?: EventImageTokens;
}> &
    Pick<CarouselProps, 'hasAutoplay' | 'autoplayOptions'>;

// TODO: When EB-227830 experiment ends, evaluate if this should be included in @eventbrite/event-renderer
export function EventCardCarousel({
    event,
    tokens,
    isLazyImage,
    linkProps,
    ...props
}: EventCardCarouselProps) {
    const images = getCarouselWidget(event);

    if (!images) {
        return null;
    }

    return (
        <Carousel className={styles.wrapper} style={tokens} {...props}>
            {images.data.slides.map((slide, index) => (
                <EventCardLink {...linkProps} key={slide.image.id}>
                    <EventCardImage
                        name={`${event.name}-${index}`}
                        loading={isLazyImage ? 'lazy' : 'eager'}
                        src={slide.image.url}
                        {...props}
                    />
                </EventCardLink>
            ))}
        </Carousel>
    );
}
